export const useMoney = () => {
  const { locale } = useI18n()
  const toNaturalMoney = (money: number, currency: string) => {
    return new Intl.NumberFormat(locale.value.replace('_', '-'), {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'CZK' ? 0 : 2,
      minimumFractionDigits: currency === 'CZK' ? 0 : 2,
    }).format(money)
  }
  return { toNaturalMoney }
}
